import React, { useState, useRef, useEffect } from 'react';
import AddOutlineIcon from '@rsuite/icons/AddOutline';
import { IconButton, Loader, Tooltip, Whisper } from 'rsuite';
import MinusIcon from '@rsuite/icons/Minus';
import ArrowLeftLineIcon from '@rsuite/icons/ArrowLeftLine';
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine';
import ArrowUpLineIcon from '@rsuite/icons/ArrowUpLine';
import ArrowDownLineIcon from '@rsuite/icons/ArrowDownLine';
import ImageUploading from 'react-images-uploading';
import Drag from './drag-and-drop.jpg';
import AllProductSlide from './AllProductSlide';
import ImageIcon from '@rsuite/icons/Image';
import PlusIcon from '@rsuite/icons/Plus';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ugr from '@/UGRoute';
export default function ProductViewInImage() {
  const navigate = useNavigate();
  const [bgImage, setBgImage] = useState();
  const [ImagesSlide, setImagesSlide] = useState(false);
  const [dragAndDropImages, setDragAndDropImages] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [draggedImagePosition, setDraggedImagePosition] = useState({ x: 0, y: 0 });
  const [widthHeight, setWidthHeight] = useState([]);
  const [productSlide, setProductSlide] = useState(false);
  const rotateTimer = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [clickableImgRef, setClickableImgRef] = useState(0);
  const [isShowButtons, setIsShowButtons] = useState({
    ppt: false,
    filter: false,
    slideShow: true,
    SmartSearch: false,
    visualProduct: false
  });
  useEffect(() => {
    const fetchData = async () => {
      const {
        data: {
          data: { attributes }
        }
      } = await axios.get(
        `${globalIP}/api/client-logins/${sessionStorage.getItem('user_id')}?populate=*`
      );
      setIsShowButtons(prev => ({
        ppt: attributes.downloadppt,
        filter: attributes.showfilter,
        slideShow: attributes.SlideShow == null || attributes.SlideShow == false ? false : true,
        SmartSearch:
          attributes.SmartSearch == null || attributes.SmartSearch == false ? false : true
      }));
    };
    fetchData();
  }, []);
  if (isShowButtons.visualProduct) {
    navigate(`/${ugr}/client/home-page`)
  }
  const handleDragStart = (e, id, index) => {
    setIsDragging(true);
    setClickableImgRef(index);
    e.dataTransfer.setData('text/plain', id);
  };
  const handleDragOver = e => {
    e.preventDefault();
  };
  const handleDrop = e => {
    e.preventDefault();
    setIsDragging(false);
    const droppedItemId = e.dataTransfer.getData('text/plain');
    const droppedItem = document.getElementById(droppedItemId);
    const rect = e.currentTarget.getBoundingClientRect();
    const offsetX = e.clientX - rect.left - droppedItem.width / 2;
    const offsetY = e.clientY - rect.top - droppedItem.height / 2;
    droppedItem.style.transition = 'left 0.3s ease, top 0.3s ease';
    droppedItem.style.position = 'absolute';
    droppedItem.style.left = offsetX + 'px';
    droppedItem.style.top = offsetY + 'px';
    droppedItem.style.transform = `rotate(${rotationDegrees}deg)`;
    droppedItem.style.opacity = 1;
  };

  const handleMouseMove = e => {
    if (isDragging) {
      const newImageX = e.clientX;
      const newImageY = e.clientY;
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      const imageWidth = widthHeight.width;
      const imageHeight = widthHeight.height;

      let adjustedX = newImageX;
      let adjustedY = newImageY;

      if (newImageX < 0) {
        adjustedX = 0;
      } else if (newImageX + imageWidth > screenWidth) {
        adjustedX = screenWidth - imageWidth;
      }

      if (newImageY < 0) {
        adjustedY = 0;
      } else if (newImageY + imageHeight > screenHeight) {
        adjustedY = screenHeight - imageHeight;
      }
      setDraggedImagePosition({ x: adjustedX, y: adjustedY });
    }
  };

  const [rotationDegrees, setRotationDegrees] = useState([]);

  const rotateLeft = index => {
    setRotationDegrees(prev => {
      let upadte = [...prev];
      upadte[index].y = upadte[index].y - 2;
      return upadte;
    });
  };

  const rotateRight = index => {
    setRotationDegrees(prev => {
      let upadte = [...prev];
      upadte[index].y = upadte[index].y + 2;
      return upadte;
    });
  };
  const rotateUp = index => {
    setRotationDegrees(prev => {
      let upadte = [...prev];
      upadte[index].x = upadte[index].x + 2;
      return upadte;
    });
  };

  const rotateDown = index => {
    setRotationDegrees(prev => {
      let upadte = [...prev];
      upadte[index].x = upadte[index].x - 2;
      return upadte;
    });
  };
  const inCreaseWidth = index => {
    setWidthHeight(prev => {
      let update = [...prev];
      update[index].width = update[index].width + 2;
      return update;
    });
  };
  const inCreaseHeight = index => {
    setWidthHeight(prev => {
      let update = [...prev];
      update[index].height = update[index].height + 2;
      return update;
    });
  };
  const deCreaseWidth = index => {
    setWidthHeight(prev => {
      let update = [...prev];
      update[index].width = update[index].width - 2;
      return update;
    });
  };
  const deCreaseHeight = index => {
    setWidthHeight(prev => {
      let update = [...prev];
      update[index].height = update[index].height - 2;
      return update;
    });
  };
  useEffect(() => {
    const scrollToBottom = () => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      });
    };
    scrollToBottom();
  }, []);
  const startRotatingUp = () => {
    rotateUp(clickableImgRef);
    rotateTimer.current = setTimeout(startRotatingUp, 100);
  };
  const startRotatingDown = () => {
    rotateDown(clickableImgRef);
    rotateTimer.current = setTimeout(startRotatingDown, 100);
  };
  const startRotatingLeft = () => {
    rotateLeft(clickableImgRef);
    rotateTimer.current = setTimeout(startRotatingLeft, 100);
  };
  const startRotatingRight = () => {
    rotateRight(clickableImgRef);
    rotateTimer.current = setTimeout(startRotatingRight, 100);
  };
  const startIncreaseWidth = () => {
    inCreaseWidth(clickableImgRef);
    rotateTimer.current = setTimeout(startIncreaseWidth, 100);
  };
  const startIncreaseHeight = () => {
    inCreaseHeight(clickableImgRef);
    rotateTimer.current = setTimeout(startIncreaseHeight, 100);
  };
  const startDecreaseWidth = () => {
    deCreaseWidth(clickableImgRef);
    rotateTimer.current = setTimeout(startDecreaseWidth, 100);
  };
  const startDecreaseHeight = () => {
    deCreaseHeight(clickableImgRef);
    rotateTimer.current = setTimeout(startDecreaseHeight, 100);
  };

  const stopRotating = () => {
    clearTimeout(rotateTimer.current);
  };
  const onChange = imageList => {
    setBgImage(imageList);
  };

  return (
    <>
      {bgImage && (
        <div>
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: `calc(100vh - 51px)`,
              overflow: 'hidden',
              perspective: '2000px'
            }}
            id="screenshot-container"
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            onMouseMove={handleMouseMove}
          >
            {dragAndDropImages.length &&
              dragAndDropImages.map((image, index) => (
                <img
                  key={index}
                  id={`img-${index}`}
                  src={`${globalIP}${image.images}`}
                  alt={`Draggable Source Image ${index}`}
                  onClick={() => setClickableImgRef(index)}
                  onDragStart={e => handleDragStart(e, `img-${index}`, index)}
                  style={{
                    opacity: isDragging && clickableImgRef == index ? 0.5 : 1,
                    zIndex: 2,
                    position: 'absolute',
                    top: draggedImagePosition.y + 'px',
                    left: draggedImagePosition.x + 'px',
                    transition: isDragging ? 'none' : 'left 0.3s ease, top 0.3s ease',
                    transform: `rotateX(${rotationDegrees[index]?.x}deg) rotateY(${rotationDegrees[index]?.y}deg) rotateZ(${rotationDegrees[index]?.z}deg)`,
                    cursor: 'move',
                    width: `${widthHeight[index].width}px`,
                    height: `${widthHeight[index].height}px`
                  }}
                />
              ))}
            <img
              id="HI"
              src={bgImage ? bgImage[0]?.data_url : null}
              alt="Drop Target Image"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '93vh'
              }}
            />
            <div
              style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                zIndex: 100,
                display: 'flex',
                gap: '20px'
              }}
            >
              <Whisper
                trigger="hover"
                placement={'top'}
                controlId={`control-id-${'bottom'}`}
                speaker={<Tooltip>Upload Image</Tooltip>}
              >
                <IconButton
                  icon={<ImageIcon />}
                  onClick={() => {
                    setBgImage(false);
                    setDraggedImagePosition({ x: 0, y: 0 });
                    setDragAndDropImages([]);
                  }}
                />
              </Whisper>
              <Whisper
                trigger="hover"
                placement={'top'}
                controlId={`control-id-${'bottom'}`}
                speaker={<Tooltip>Rotate Left</Tooltip>}
              >
                <IconButton
                  onMouseDown={startRotatingLeft}
                  onMouseUp={stopRotating}
                  onTouchStart={startRotatingLeft}
                  onTouchEnd={stopRotating}
                  icon={<ArrowLeftLineIcon />}
                />
              </Whisper>
              <Whisper
                trigger="hover"
                placement={'top'}
                controlId={`control-id-${'bottom'}`}
                speaker={<Tooltip>Rotate Right</Tooltip>}
              >
                <IconButton
                  onMouseDown={startRotatingRight}
                  onMouseUp={stopRotating}
                  onTouchStart={startRotatingRight}
                  onTouchEnd={stopRotating}
                  icon={<ArrowRightLineIcon />}
                />
              </Whisper>
              <Whisper
                trigger="hover"
                placement={'top'}
                controlId={`control-id-${'bottom'}`}
                speaker={<Tooltip>Rotate Up</Tooltip>}
              >
                <IconButton
                  onMouseDown={startRotatingUp}
                  onMouseUp={stopRotating}
                  onTouchStart={startRotatingUp}
                  onTouchEnd={stopRotating}
                  icon={<ArrowUpLineIcon />}
                />
              </Whisper>
              <Whisper
                trigger="hover"
                placement={'top'}
                controlId={`control-id-${'bottom'}`}
                speaker={<Tooltip>Rotate Down</Tooltip>}
              >
                <IconButton
                  onMouseDown={startRotatingDown}
                  onMouseUp={stopRotating}
                  onTouchStart={startRotatingDown}
                  onTouchEnd={stopRotating}
                  icon={<ArrowDownLineIcon />}
                />
              </Whisper>
              <Whisper
                trigger="hover"
                placement={'top'}
                controlId={`control-id-${'bottom'}`}
                speaker={<Tooltip>Width Increase</Tooltip>}
              >
                <IconButton
                  onMouseDown={startIncreaseWidth}
                  onMouseUp={stopRotating}
                  onTouchStart={startIncreaseWidth}
                  onTouchEnd={stopRotating}
                  icon={<PlusIcon />}
                />
              </Whisper>
              <Whisper
                trigger="hover"
                placement={'top'}
                controlId={`control-id-${'bottom'}`}
                speaker={<Tooltip>Width Decrease</Tooltip>}
              >
                <IconButton
                  onMouseDown={startDecreaseWidth}
                  onMouseUp={stopRotating}
                  onTouchStart={startDecreaseWidth}
                  onTouchEnd={stopRotating}
                  icon={<MinusIcon />}
                />
              </Whisper>
              <Whisper
                trigger="hover"
                placement={'top'}
                controlId={`control-id-${'bottom'}`}
                speaker={<Tooltip>Height Increase</Tooltip>}
              >
                <IconButton
                  onMouseDown={startIncreaseHeight}
                  onMouseUp={stopRotating}
                  onTouchStart={startIncreaseHeight}
                  onTouchEnd={stopRotating}
                  icon={<PlusIcon />}
                />
              </Whisper>
              <Whisper
                trigger="hover"
                placement={'left'}
                controlId={`control-id-${'bottom'}`}
                speaker={<Tooltip>Height Decrease</Tooltip>}
              >
                <IconButton
                  onMouseDown={startDecreaseHeight}
                  onMouseUp={stopRotating}
                  onTouchStart={startDecreaseHeight}
                  onTouchEnd={stopRotating}
                  icon={<MinusIcon />}
                />
              </Whisper>
            </div>
          </div>
        </div>
      )}
      {!bgImage && (
        <div className="App" style={{ width: '100%', height: '100vh' }}>
          <ImageUploading value={bgImage} onChange={onChange} maxNumber={10} dataURLKey="data_url">
            {({ imageList, onImageUpload, isDragging, dragProps }) => (
              <div style={{ height: '250px' }}>
                <button
                  style={
                    isDragging
                      ? { color: 'red', fontSize: '15px', height: '100vh !important' }
                      : { fontSize: '15px', height: '100vh !important' }
                  }
                  onClick={onImageUpload}
                  {...dragProps}
                  className="image-uploader-1"
                >
                  {imageList.length ? null : (
                    <>
                      <img src={Drag} alt="" />
                      <br />
                      Drag an image here or upload a file
                    </>
                  )}
                  {imageList.map((image, index) => (
                    <div key={index} className="image-item">
                      <img src={image['data_url']} alt="" width="100" />
                    </div>
                  ))}
                </button>
              </div>
            )}
          </ImageUploading>
        </div>
      )}
      <AllProductSlide
        open={productSlide}
        close={() => setProductSlide(false)}
        setImagesSlide={setImagesSlide}
        ImagesSlide={ImagesSlide}
        setDragAndDropImages={setDragAndDropImages}
        setIsLoading={setIsLoading}
        setRotationDegrees={setRotationDegrees}
        setWidthHeight={setWidthHeight}
      />
      {isLoading && (
        <div
          style={{
            width: '100%',
            height: '100vh',
            position: 'absolute',
            top: '0',
            left: 0,
            zIndex: 1000000,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Loader size="md" content="Loading" color="cyan" />
        </div>
      )}
      {bgImage && (
        <div style={{ position: 'absolute', right: 0, top: '50%', zIndex: 100 }}>
          <Whisper
            trigger="hover"
            placement={'left'}
            controlId={`control-id-${'bottom'}`}
            speaker={<Tooltip>Show Products</Tooltip>}
          >
            <IconButton
              icon={<AddOutlineIcon color="white" />}
              onClick={() => setProductSlide(true)}
              appearance="primary"
              color="cyan"
              style={{ borderRadius: 0, borderTopLeftRadius: '5px', borderBottomLeftRadius: '5px' }}
            />
          </Whisper>
        </div>
      )}
    </>
  );
}
